import React from 'react';
import styles from './mainform.module.scss';
import mwuLogo from '../mwu-logo.webp';

const MainForm = ({
  formData,
  emptyRows,
  handleInputChange,
  handleDateInput,
  handleReportNumberInput,
  handleRowChange,
  addNewRow,
  removeRow,
  handleSubmit,
  isSubmitting,
  selectedFormForUpdate,
  signatures,
  signatureVisibility,
  handleSignatureVisibility,
  setSelectedFormForUpdate,
  setShowUpdateForm,
  setActiveTab,
  clearFormData,
  handleCancelUpdate
}) => {
  return (
    <div>
      {/* Mode Indicators */}
      {selectedFormForUpdate ? (
        <div style={{
          background: 'linear-gradient(135deg, #ffc107, #ff9800)',
          color: 'white',
          padding: '10px 20px',
          marginBottom: '20px',
          borderRadius: '8px',
          textAlign: 'center',
          fontWeight: 'bold',
          boxShadow: '0 4px 15px rgba(255, 193, 7, 0.3)'
        }}>
          ✏️ फारम सम्पादन मोड - फारम नं.: {selectedFormForUpdate.form_number || 'N/A'}
        </div>
      ) : (
        <div style={{
          background: 'linear-gradient(135deg, #4CAF50, #45a049)',
          color: 'white',
          padding: '10px 20px',
          marginBottom: '20px',
          borderRadius: '8px',
          textAlign: 'center',
          fontWeight: 'bold',
          boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)'
        }}>
          ➕ नयाँ फारम सिर्जना मोड
        </div>
      )}

      {/* Header Section */}
      <div className={styles.header}>
        <div className={styles.logo}>
          <img 
            src={mwuLogo} 
            alt="मध्यपश्चिम विश्वविद्यालय लोगो" 
            className={styles.logoImage}
          />
        </div>
        <div className={styles.right}>म.ले.प.फा.नं. ४०३</div>
        <div className={styles.clear}></div>
        <div className={styles.center}>
          <p className={styles.universityName}>
            मध्यपश्चिम विश्वविद्यालय
          </p>
          <p className={styles.officeName}>
            <input
              type="text"
              value={formData.officeName || 'कार्यालय'}
              onChange={(e) => handleInputChange('officeName', e.target.value)}
              className={`${styles.underline} ${styles.officeName}`}
              placeholder="कार्यालय"
            />
          </p>
          <p className={styles.officeAddress}>
            <input
              type="text"
              value={formData.officeAddress || 'वीरेन्द्रनगर, सुर्खेत'}
              onChange={(e) => handleInputChange('officeAddress', e.target.value)}
              className={`${styles.underline} ${styles.officeAddress}`}
              placeholder="वीरेन्द्रनगर, सुर्खेत"
            />
          </p>
          <p className={styles.officeCode}>
            <span>कार्यालय कोड नं.:</span>
            <input
              type="text"
              value={formData.officeCode || ''}
              onChange={(e) => handleInputChange('officeCode', e.target.value)}
              className={`${styles.underline} ${styles.officeCode}`}
              placeholder="कोड नं."
            />
          </p>
        </div>
      </div>

      {/* Main Title */}
      <div className={styles.mainTitle}>
        <h1>
          दाखिला प्रतिवेदन फाराम
        </h1>
      </div>

      {/* Form Fields - Right Aligned */}
      <div className={`${styles.formSection} ${styles.rightAlign}`}>
        <div className={styles.formRow}>
          <span className={styles.label}>दाखिला मितिः</span>
          <input
            type="text"
            value={formData.admissionDate}
            onChange={(e) => handleDateInput('admissionDate', e.target.value)}
            className={styles.underline}
            placeholder="mm/dd/yyyy या मिति"
          />
        </div>
        <div className={styles.formRow}>
          <span className={styles.label}>दाखिला प्रतिवेदन नं.:</span>
          <input
            type="text"
            value={formData.admissionReportNumber}
            onChange={(e) => handleReportNumberInput('admissionReportNumber', e.target.value)}
            className={styles.underline}
            placeholder="प्रतिवेदन नं. या Report No."
          />
        </div>
      </div>

      {/* Items Table */}
      <div className={styles.tableContainer}>
        <table className={styles.table}>
        <thead>
          <tr>
            <th rowSpan="2">क्र.सं.</th>
            <th rowSpan="2">खरिद आदेश / हस्तान्तरण फारम नं.</th>
            <th rowSpan="2">जिन्सी वर्गीकरण संकेत नं.</th>
            <th rowSpan="2">जिन्सी खाता पाना नं.</th>
            <th rowSpan="2">सामानको नाम</th>
                            <th rowSpan="2">स्पेसिफिकेशन</th>
            <th rowSpan="2">सामानको पहिचान नं.</th>
            <th rowSpan="2">मोडल नं.</th>
            <th colSpan="6">मूल्य (बिल बिजक अनुसार)</th>
            <th rowSpan="2">अन्य खर्च</th>
            <th rowSpan="2">अन्य खर्च समेत जम्मा रकम</th>
            <th rowSpan="2">कैफियत</th>
            <th rowSpan="2">कार्य</th>
          </tr>
          <tr>
            <th>इकाई</th>
            <th>परिमाण</th>
            <th>दर</th>
            <th>जम्मा मु.अ.कर बाहेक</th>
            <th>मु.अ.कर</th>
            <th>सामानको जम्मा मूल्य</th>
          </tr>
        </thead>
        <tbody>
          {/* First row with numbers १-१७ */}
          <tr>
            <td>१</td>
            <td>२</td>
            <td>३</td>
            <td>४</td>
            <td>५</td>
            <td>६</td>
            <td>७</td>
            <td>८</td>
            <td>९</td>
            <td>१०</td>
            <td>११</td>
            <td>१२</td>
            <td>१३</td>
            <td>१४=१२+१३</td>
            <td>१५</td>
            <td>१६=१४+१५</td>
            <td>१७</td>
            <td></td>
          </tr>
          
          {/* Dynamic rows */}
          {emptyRows.map((row, index) => (
            <tr key={index}>
                             <td>
                 <input
                   type="text"
                   value={row.serialNumber}
                   onChange={(e) => {
                     console.log('Typing in serialNumber:', e.target.value);
                     handleRowChange(row.id, 'serialNumber', e.target.value);
                   }}
                   onFocus={(e) => console.log('Focused on serialNumber input')}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.purchaseOrderNumber}
                   onChange={(e) => handleRowChange(row.id, 'purchaseOrderNumber', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.classificationCode}
                   onChange={(e) => handleRowChange(row.id, 'classificationCode', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.ledgerPageNumber}
                   onChange={(e) => handleRowChange(row.id, 'ledgerPageNumber', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.itemName}
                   onChange={(e) => handleRowChange(row.id, 'itemName', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.specification}
                   onChange={(e) => handleRowChange(row.id, 'specification', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.itemIdentificationNumber}
                   onChange={(e) => handleRowChange(row.id, 'itemIdentificationNumber', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.modelNumber}
                   onChange={(e) => handleRowChange(row.id, 'modelNumber', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.unit}
                   onChange={(e) => handleRowChange(row.id, 'unit', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.quantity}
                   onChange={(e) => handleRowChange(row.id, 'quantity', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.rate}
                   onChange={(e) => handleRowChange(row.id, 'rate', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.totalExcludingVAT}
                   onChange={(e) => handleRowChange(row.id, 'totalExcludingVAT', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.vat}
                   onChange={(e) => handleRowChange(row.id, 'vat', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.totalItemValue}
                   onChange={(e) => handleRowChange(row.id, 'totalItemValue', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.otherExpenses}
                   onChange={(e) => handleRowChange(row.id, 'otherExpenses', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.totalWithOtherExpenses}
                   onChange={(e) => handleRowChange(row.id, 'totalWithOtherExpenses', e.target.value)}
                 />
               </td>
               <td>
                 <input
                   type="text"
                   value={row.remarks}
                   onChange={(e) => handleRowChange(row.id, 'remarks', e.target.value)}
                 />
               </td>
              <td>
                <button onClick={() => removeRow(row.id)}>हटाउनुहोस्</button>
              </td>
            </tr>
          ))}
                  </tbody>
        </table>
      </div>

             {/* Add Row Button */}
       <div className={styles.addRowButton}>
         <button onClick={addNewRow}>+ नयाँ पङ्क्ति थप्नुहोस्</button>
       </div>

      {/* Footer Section with Signatures */}
      <div className={styles.ddd}>
        <p>उपरोक्त अनुसार दाखिला प्रतिवेदन तयार गर्ने, जाँच गर्ने र स्वीकृत गर्नेः</p>
        <div className={styles.signature}>
          <div>
            <p>
              <span 
                onClick={() => handleSignatureVisibility('fontwalSignature')}
                style={{ 
                  cursor: 'pointer', 
                  color: signatureVisibility?.fontwalSignature ? '#007bff' : '#000'
                }}
              >
                फाँटवालाको दस्तखतः
              </span> 
              {signatures?.fontwalSignature && signatureVisibility?.fontwalSignature && (
                <img 
                  src={signatures.fontwalSignature.preview || signatures.fontwalSignature.url} 
                  alt="फाँटवालाको दस्तखत" 
                  style={{ 
                    maxWidth: '120px', 
                    maxHeight: '60px', 
                    objectFit: 'contain',
                    marginLeft: '10px',
                    verticalAlign: 'middle',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    background: 'white',
                    padding: '2px'
                  }}
                />
              )}
            </p>
            <p>नाम: <input 
              type="text"
              value={formData.fontwalName}
              onChange={(e) => handleInputChange('fontwalName', e.target.value)}
              placeholder={formData.fontwalName ? '' : "नाम"}
            /></p>
            <p>पद: <input 
              type="text"
              value={formData.fontwalDesignation}
              onChange={(e) => handleInputChange('fontwalDesignation', e.target.value)}
              placeholder={formData.fontwalDesignation ? '' : "पद"}
            /></p>
            <p>मिति: <input 
              type="text"
              value={formData.fontwalDate}
              onChange={(e) => handleDateInput('fontwalDate', e.target.value)}
              placeholder={formData.fontwalDate ? '' : "मिति"}
            /></p>
          </div>
          <div>
            <p>
              <span 
                onClick={() => handleSignatureVisibility('branchHeadSignature')}
                style={{ 
                  cursor: 'pointer', 
                  color: signatureVisibility?.branchHeadSignature ? '#007bff' : '#000'
                }}
              >
                भण्डार प्रमुखको दस्तखतः
              </span> 
              {signatures?.branchHeadSignature && signatureVisibility?.branchHeadSignature && (
                <img 
                  src={signatures.branchHeadSignature.preview || signatures.branchHeadSignature.url} 
                  alt="भण्डार प्रमुखको दस्तखत" 
                  style={{ 
                    maxWidth: '120px', 
                    maxHeight: '60px', 
                    objectFit: 'contain',
                    marginLeft: '10px',
                    verticalAlign: 'middle',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    background: 'white',
                    padding: '2px'
                  }}
                />
              )}
            </p>
            <p>नाम: <input 
              type="text"
              value={formData.branchHeadName}
              onChange={(e) => handleInputChange('branchHeadName', e.target.value)}
              placeholder={formData.branchHeadName ? '' : "नाम"}
            /></p>
            <p>पद: <input 
              type="text"
              value={formData.branchHeadDesignation}
              onChange={(e) => handleInputChange('branchHeadDesignation', e.target.value)}
              placeholder={formData.branchHeadDesignation ? '' : "पद"}
            /></p>
            <p>मिति: <input 
              type="text"
              value={formData.branchHeadDate}
              onChange={(e) => handleDateInput('branchHeadDate', e.target.value)}
              placeholder={formData.branchHeadDate ? '' : "मिति"}
            /></p>
          </div>
          <div>
            <p>
              <span 
                onClick={() => handleSignatureVisibility('officeHeadSignature')}
                style={{ 
                  cursor: 'pointer', 
                  color: signatureVisibility?.officeHeadSignature ? '#007bff' : '#000'
                }}
              >
                प्रमाणित गर्नेको दस्तखतः
              </span> 
              {signatures?.officeHeadSignature && signatureVisibility?.officeHeadSignature && (
                <img 
                  src={signatures.officeHeadSignature.preview || signatures.officeHeadSignature.url} 
                  alt="प्रमाणित गर्नेको दस्तखत" 
                  style={{ 
                    maxWidth: '120px', 
                    maxHeight: '60px', 
                    objectFit: 'contain',
                    marginLeft: '10px',
                    verticalAlign: 'middle',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    background: 'white',
                    padding: '2px'
                  }}
                />
              )}
            </p>
            <p>नाम: <input 
              type="text"
              value={formData.officeHeadName}
              onChange={(e) => handleInputChange('officeHeadName', e.target.value)}
              placeholder={formData.officeHeadName ? '' : "नाम"}
            /></p>
            <p>पद: <input 
              type="text"
              value={formData.officeHeadDesignation}
              onChange={(e) => handleInputChange('officeHeadDesignation', e.target.value)}
              placeholder={formData.officeHeadDesignation ? '' : "पद"}
            /></p>
            <p>मिति: <input 
              type="text"
              value={formData.officeHeadDate}
              onChange={(e) => handleDateInput('officeHeadDate', e.target.value)}
              placeholder={formData.officeHeadDate ? '' : "मिति"}
            /></p>
          </div>
        </div>
      </div>

      {/* Form Actions */}
      <div className={styles.formActions}>
        <button 
          className={styles.submitBtn} 
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting 
            ? (selectedFormForUpdate ? 'अपडेट गर्दै...' : 'सेभ गर्दै...') 
            : (selectedFormForUpdate ? 'फारम अपडेट गर्नुहोस्' : 'फारम सेभ गर्नुहोस्')
          }
        </button>
        {selectedFormForUpdate && (
          <button 
            className={styles.cancelBtn}
            onClick={handleCancelUpdate}
          >
            रद्द गर्नुहोस्
          </button>
        )}
        <button className={styles.printBtn}>
          प्रिन्ट गर्नुहोस्
        </button>
      </div>
    </div>
  );
};

export default MainForm;
